export default __webpack_public_path__ + "static/media/bublLogo.da74d6a5.png";